import React from 'react';
import { connect } from 'react-redux';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { getQuestionScore, getStudentScore, getTotalScore } from '../../../util/mission';
import AbilityPointsRadarChart from './AbilityPointsRadarChart';
import { PRIMARY_ABILITY_POINTS_DICT } from '../../../dto/chart';
import AbilityPieChart from './AbilityPointPieChart';

function Component(props) {
    const { id } = useParams();
    const navigate = useNavigate();

    let [searchParams, setSearchParams] = useSearchParams();


    const mission = props.mission||{}
    const data = props.data

    const getAbilityPointsLabel = () => {
        let array = [];
        for(let i = 0; i < mission?.questions?.length; i++) {
            const question = mission?.questions[i];
            if((!['短句作答題', '選擇題 + 短句作答題'].includes(question.type)) && question.score>0 && question?.abilityPoint && !array.includes(question.abilityPoint)) {
                array.push(question.abilityPoint);
            }
        }
        return array;
    }

    const getAbilityPointsData = () => {
        let array = [];
        for(let label of getAbilityPointsLabel()) {
            let total=0
            let count=0
            for(let i = 0; i < data?.length; i++) {
                if(data[i]?.questions) {
                    for(let j = 0; j < data[i]?.questions.length; j++) {
                        const question = data[i]?.questions[j];
                        if(mission?.questions?.[j]?.abilityPoint === label) {
                            let studentScore = getQuestionScore(question);
                            let questionScore = question.score||0;
                            if(questionScore > 0) {
                                total += questionScore;
                                count += studentScore;
                            }
                            
                        }
                    }
                }
            }
            array.push({
                total,count,label,
            });
        }
        return array;
    }
    if(data.length===0) return(
        <div className='h-full flex-1 bg-[#F2F2F2] flex-col flex p-[16px] gap-[16px]' style={{ overflowY: "auto" }}>
            <div className='p-[16px] flex flex-row items-center justify-between items-center bg-[white] rounded-[10px] gap-[8px] flex-wrap'>
                <div className='text-[#212121] text-[20px] font-[700]'>沒有任何學生的成績</div>
                
            </div>
        </div>
    )
    return (
        <div className='h-full flex-1 bg-[#F2F2F2] flex-col flex p-[16px] gap-[16px]' style={{ overflowY: "auto" }}>
            {/*title, filter, serach box*/}
            <div className='p-[16px] flex flex-row items-center justify-between items-center bg-[white] rounded-[10px] gap-[8px] flex-wrap'>
                <div className='text-[#212121] text-[20px] font-[700]'>閲讀任務名稱: {mission?.name}</div>
                <div className='flex flex-row items-center gap-[8px] flex-wrap'>
                    <div className='cursor-pointer text-[blue] underline text-[12px]' onClick={()=>{navigate(`/platform2/studentmissions/${id}`)}}>返回</div>
                </div>
            </div>
            {/*end of title, filter, serach box*/}

            <div className='flex flex-row w-full items-stretch gap-[16px] flex-wrap'>
                <div className='flex-1 max-w-[400px] min-w-[400px] flex flex-col bg-[white] rounded-[10px] p-[16px] text-[14px] justify-start items-center'>
                    <div className='w-full pb-[4px]'>成績能力點</div>
                    <AbilityPointsRadarChart data={getAbilityPointsData()}/>
                    <div className='w-full flex flex-col items-center justify-center gap-[8px]'>
                        {getAbilityPointsLabel().map((item,index)=>
                            <div key={index} className='w-full flex flex-col items-start gap-[8px] justify-center'>
                                <div className='text-[12px]'>{PRIMARY_ABILITY_POINTS_DICT[item]}</div>
                            </div>
                        )}
                    </div>
                </div>
                <div className='flex-1 flex flex-col bg-[white] rounded-[10px] p-[16px] text-[14px] min-w-[400px]'>
                    <div className='w-full pb-[4px]'>成績能力點</div>
                    <div className='w-full flex flex-row items-start justify-start flex-wrap gap-[16px] rounded-[10px] p-[6px] text-[black]'>
                        {getAbilityPointsData().map((item,index)=>
                            <div key={index} className='p-[24px] flex flex-col items-center justify-center max-w-[200px]'>
                                <div className='text-[12px] h-[60px]'>{PRIMARY_ABILITY_POINTS_DICT[item.label]}</div>
                                <AbilityPieChart data={item}/>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default connect((store) => {
    return {
        token: store.tokenReducer,
    }
})(Component)
